<template>
    <div class="video-controls-panel">
        <synchronized-video-controls />

        <synchronized-video-seek-bar v-b-tooltip.hover :disabled="isDisabled" :title="title" />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { VIDEO_SEEK_MODES } from '../../../business/const'
import SynchronizedVideoSeekBar from '../common/SynchronizedVideoSeekBar'
import SynchronizedVideoControls from '../common/SynchronizedVideoControls'

export default {
    name: 'VideoControlsPanel',
    components: {
        SynchronizedVideoSeekBar,
        SynchronizedVideoControls
    },
    data() {
        return {
            VIDEO_SEEK_MODES
        }
    },
    computed: {
        ...mapState({
            videoSeekMode: state => state.video.videoSeekMode,
            isFertilizationCheck: state => state.video.isFertilizationCheck
        }),
        title() {
            if (this.videoSeekMode === VIDEO_SEEK_MODES.MK_EVENT)
                return this.$translate('seeking_not_available_in_events_mode')
            if (this.isFertilizationCheck)
                return this.$translate('seeking_not_available_in_fert_check_mode')
            return ''
        },
        isDisabled() {
            return this.videoSeekMode === VIDEO_SEEK_MODES.MK_EVENT || this.isFertilizationCheck
        }
    }
}
</script>

<style lang="scss" scoped>
.video-controls-panel {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    padding: 0.5rem 1rem;

    .synchronized-video-seek-bar {
        margin-left: 1.5rem;
        flex-grow: 1;
    }

    @media screen and #{$new-break3close} {
        background-color: $dark-4;
    }
}
</style>
